import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import router from '@/admin/router';
import { DrawerProvider } from '@/admin/context/DrawerContext';
import { ProcessingProvider } from '@/school-management/context/ProcessingContext';
// import '@/admin/assets/styles/global.scss';
// import '@/admin/assets/styles/global.css';
// import 'react-modern-drawer/dist/index.css';

const System = () => {
  return (
    <DrawerProvider>
      <ProcessingProvider>
        <RouterProvider router={router} />
      </ProcessingProvider>
      <ToastContainer />
    </DrawerProvider>
  );
};

export default System;
